import React from "react";

export default function statusCyclotocht(color){
	return (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		id="Laag_2"
		viewBox="0 0 51 51"
		width="51px"
		height="80px"
		version="1.1"
		xmlSpace="preserve"
		>
		<g transform="matrix(1.33333 0 0 -1.33333 0 50.227)">
		<g
		fill={"none"}
		stroke="#033E51"
		strokeLinecap="butt"
		strokeMiterlimit="10"
		strokeOpacity="1"
		strokeWidth="10"
		transform="scale(.1)"
		>
		<path
		fill="#033E51"
		strokeDasharray="none"
		strokeLinejoin="miter"
		d="M168.328 258.891v54.015"
		></path>
		<path
		fill="#033E51"
		strokeDasharray="none"
		strokeLinejoin="miter"
		d="M89.05 312.906v-54.015"
		></path>
		<path
		fill="#033E51"
		strokeDasharray="none"
		strokeLinejoin="miter"
		d="M177.734 304.043l-49.726 40.602-49.739-40.602"
		></path>
		<path
		fill="#033E51"
		strokeDasharray="none"
		strokeLinejoin="round"
		d="M291.746 258.891V338.5"
		></path>
		<path
		fill="#033E51"
		strokeDasharray="none"
		strokeLinejoin="round"
		d="M212.469 338.5v-79.609"
		></path>
		<path
		fill="#033E51"
		strokeDasharray="none"
		strokeLinejoin="miter"
		d="M301.152 329.637l-49.726 40.605-49.738-40.605"
		></path>
		<path
		fill="#033E51"
		strokeDasharray="none"
		strokeLinejoin="miter"
		d="M182.781 286.582v-27.691"
		></path>
		<path
		fill="#033E51"
		strokeDasharray="none"
		strokeLinejoin="miter"
		d="M187.598 282.035l-20.539 16.77"
		></path>
		<path
		fill="#033E51"
		strokeDasharray="none"
		strokeLinejoin="miter"
		d="M6.113 132.195h25"
		></path>
		<path
		fill="#033E51"
		strokeDasharray="52.6325, 21.053"
		strokeDashoffset="0"
		strokeLinejoin="miter"
		d="M52.156 132.195h284.219"
		></path>
		<path
		fill="#033E51"
		strokeDasharray="none"
		strokeLinejoin="miter"
		d="M346.902 132.195h25"
		></path>
		<path
		strokeDasharray="none"
		strokeLinejoin="miter"
		d="M334.676 5H5v254.395h369.676V45c0-22.09-17.91-40-40-40z"
		></path>
		</g>
		</g>
</svg>);
}